module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAElBMVEUAAABicZlicZlicZlicZlicZn1LVSbAAAABXRSTlMAOx7DxI8ndU8AAAA2SURBVBjTYyALMIdCgQGQwyoYKCoI4gRgcEAMGAcBUGTwcxRAipmwyzDh1MNE2GiEFxzICgEAQBgncjmHQiEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_website.png
// module id = VyCK
// module chunks = 9